import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=5628%3A736
 *
 * @param {SvgIconProps} props - svg props
 */
export const StopIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M20 6.08333V17.1667C20 20 18.5 21.5 15.7273 21.5H10.7545C9.87091 21.5 9.03636 21.1417 8.42273 20.5083L2.70512 13.6982C2.32665 13.2474 2.41692 12.5678 2.90243 12.2351C3.00812 12.1626 3.08195 12.1125 3.09023 12.1083C3.27023 11.95 3.49114 11.8667 3.73659 11.8667C3.91659 11.8667 4.08023 11.9167 4.2275 12C4.25368 12.0067 6.47719 13.1277 7.36606 13.5761C7.53235 13.66 7.72727 13.5384 7.72727 13.3521V4.83333C7.72727 4.14167 8.27545 3.58333 8.95455 3.58333C9.63364 3.58333 10.1818 4.14167 10.1818 4.83333V10.4167C10.1818 10.5547 10.2937 10.6667 10.4318 10.6667H10.75C10.8881 10.6667 11 10.5547 11 10.4167V2.75C11 2.05833 11.5482 1.5 12.2273 1.5C12.9064 1.5 13.4545 2.05833 13.4545 2.75V10.4167C13.4545 10.5547 13.5665 10.6667 13.7045 10.6667H14.0227C14.1608 10.6667 14.2727 10.5547 14.2727 10.4167V3.58333C14.2727 2.89167 14.8209 2.33333 15.5 2.33333C16.1791 2.33333 16.7273 2.89167 16.7273 3.58333V10.4167C16.7273 10.5547 16.8392 10.6667 16.9773 10.6667H17.2955C17.4335 10.6667 17.5455 10.5547 17.5455 10.4167V6.08333C17.5455 5.39167 18.0936 4.83333 18.7727 4.83333C19.4518 4.83333 20 5.39167 20 6.08333Z' fill={color}/>
        </SvgIcon>
    )
}

export default StopIcon
